import { useEffect, useState } from 'react';
import { Link, Navigate } from "react-router-dom";
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import { LogoutModal } from './logout.js';

function Dashboard() {
  const isLoggedIn = sessionStorage.getItem("userToken");
  const [fee_paid, setFeePaid] = useState({});
  const [pendingACC, setPendingACC] = useState({});
  const [pendingComplaint, setPendingComplaint] = useState({});
  const [actveResidents, setActiveResidents] = useState({});
  const [isLoading, setLoading] = useState(true);

  const getFeePaidPercentage = async() => {
    try {
      const response = await fetch('/api/fee-paid-percentage');
      const json = await response.json();
      setFeePaid(json);
    } catch (error) {
      console.log(error);
    }
  }

  const getPendingAccRequests = async() => {
    try {
      const response = await fetch('/api/pending-acc-requests');
      const json = await response.json();
      setPendingACC(json);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const getPendingComplaints = async() => {
    try {
      const response = await fetch('/api/pending-complaints');
      const json = await response.json();
      setPendingComplaint(json);
    } catch (error) {
      console.log(error);
    }
  }

  const getActiveResidents = async() => {
    try {
      const response = await fetch('/api/total-residents');
      const json = await response.json();
      setActiveResidents(json);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(()=>{
    getActiveResidents();
    getFeePaidPercentage();
    getPendingComplaints();
    getPendingAccRequests();
  }, []);

  if(isLoggedIn){
    return(
      <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <TopBar />
              <div className="container-fluid">
                <div className="row">
                  <div className="col-xs-12 col-md-12">
                    <div className="card shadow mb-4">
                      <div className="card-body">
                        <h2 className="text-center">Welcome to HOA Dashboard.</h2>

                        {/* Score cards Row */}
                        <div className="row">
                            {/* Active Residents */}
                            <div className="col-xl-3 col-md-6 mb-4">
                                <div className="card border-left-primary shadow h-100 py-2">
                                    <div className="card-body">
                                    {!isLoading &&
                                        <Link to="/residents/" className="row no-gutters align-items-center scorecard-link">
                                            <div className="col mr-2">
                                                <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                    Active Property Owners</div>
                                                <div className="h5 mb-0 font-weight-bold text-gray-800">{actveResidents.no_of_residents}</div>
                                            </div>
                                            <div className="col-auto">
                                                <i className="fas fa-users fa-2x text-gray-300"></i>
                                            </div>
                                        </Link>
                                      }
                                    </div>
                                </div>
                            </div>
                            {/* Pending Fee (Current Year) Card */}
                            <div className="col-xl-3 col-md-6 mb-4">
                                <div className="card border-left-success shadow h-100 py-2">
                                    <div className="card-body">
                                    {!isLoading &&
                                       <Link to={"/fees"}  className="row no-gutters align-items-center scorecard-link">
                                            <div className="col mr-2">
                                                <div className="text-xs font-weight-bold text-success text-uppercase mb-1">Fees Paid
                                                </div>
                                                <div className="row no-gutters align-items-center">
                                                  <div className="col-auto">
                                                    <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">{fee_paid.paid_percentage!=null?fee_paid.paid_percentage:""}</div>
                                                  </div>
                                                  <div className="col">
                                                      <div className="progress progress-sm mr-2">
                                                          <div className="progress-bar bg-success" role="progressbar"
                                                              style={{width: fee_paid.paid_percentage+"%"}} aria-valuenow={fee_paid.paid_percentage} aria-valuemin="0"
                                                              aria-valuemax="100"></div>
                                                      </div>
                                                  </div>
                                                </div>
                                            </div>
                                            <div className="col-auto">
                                                <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                                            </div>
                                        </Link>
                                      }
                                    </div>
                                </div>
                            </div>
                            {/* Pending Complaints Card */}
                            <div className="col-xl-3 col-md-6 mb-4">
                                <div className="card border-left-info shadow h-100 py-2">
                                    <div className="card-body">
                                      {!isLoading &&
                                        <Link to="/complaints/" className="row no-gutters align-items-center scorecard-link">
                                            <div className="col mr-2">
                                                <div className="text-xs font-weight-bold text-info text-uppercase mb-1">Pending Complaints
                                                </div>
                                                <div className="h5 mb-0 font-weight-bold text-gray-800">{pendingComplaint.pending}</div>
                                            </div>
                                            <div className="col-auto">
                                                <i className="fas fa-clipboard-list fa-2x text-gray-300"></i>
                                            </div>
                                        </Link>
                                      }
                                    </div>
                                </div>
                            </div>
                            {/* Pending ACC Requests Card */}
                            <div className="col-xl-3 col-md-6 mb-4">
                                <div className="card border-left-warning shadow h-100 py-2">
                                    <div className="card-body">
                                      {!isLoading &&
                                        <Link to="/acc-requests" className="row no-gutters align-items-center scorecard-link">
                                            <div className="col mr-2">
                                                <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                                                    Pending ACC Requests</div>
                                                <div className="h5 mb-0 font-weight-bold text-gray-800">{pendingACC.pending_requests}</div>
                                            </div>
                                            <div className="col-auto">
                                                <i className="fas fa-comments fa-2x text-gray-300"></i>
                                            </div>
                                        </Link>
                                      }
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <p className="text-center">Please select a menu option from the left navigation</p>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
      </>
    )
  }else{
    return (
      <Navigate to="/login" />
    );
  }
}

export { Dashboard };
